import SpeakButton from "@/components/SpeakButton";
import { useState } from "react";
import { Sun } from "lucide-react";
import { useT } from "@/i18n";
import { SAMPLE, LIGHTS, WHITE_BALANCE, PHOTO_TEXT } from "@/components/photo/content";

export const LightTips = () => {
  const { lang } = useT();
  return (
    <div>
      <div className="flex flex-wrap items-center gap-2"><h3 className="font-fredoka text-xl sm:text-2xl font-bold text-blue-950">{PHOTO_TEXT[lang].light}</h3><SpeakButton compact mascot="lumi" text={PHOTO_TEXT[lang].light} testId="ask-photo-light" /></div>
      <div className="mt-4 grid sm:grid-cols-2 lg:grid-cols-4 gap-4">
        {LIGHTS.map((l) => (
          <div key={l.id} className={`${l.color} rounded-3xl border-4 border-white p-4 shadow-md`} data-testid={`light-${l.id}`}>
            <Sun className="w-7 h-7 text-amber-500" />
            <p className="font-fredoka text-lg font-bold text-blue-950 mt-1">{l[lang][0]}</p>
            <p className="text-sm font-semibold text-blue-900">{l[lang][1]}</p>
          </div>
        ))}
      </div>
    </div>
  );
};

export const WhiteBalance = () => {
  const { lang } = useT();
  const tx = PHOTO_TEXT[lang];
  const [wb, setWb] = useState(WHITE_BALANCE[0]);
  return (
    <div>
      <div className="flex flex-wrap items-center gap-2"><h3 className="font-fredoka text-xl sm:text-2xl font-bold text-blue-950">{tx.wb}</h3><SpeakButton compact mascot="lumi" text={`${tx.wb} ${tx.wbSub}`} testId="ask-photo-wb" /></div>
      <p className="text-blue-900 font-semibold">{tx.wbSub}</p>
      <div className="mt-4 flex flex-wrap gap-2">
        {WHITE_BALANCE.map((w) => (
          <button
            key={w.id}
            type="button"
            onClick={() => setWb(w)}
            className={`rounded-full px-4 py-2 font-bold text-sm shadow ${wb.id === w.id ? "bg-blue-600 text-white" : "bg-white text-blue-900"}`}
            data-testid={`wb-${w.id}`}
          >
            {w[lang]}
          </button>
        ))}
      </div>
      <div className="mt-4 max-w-2xl rounded-3xl overflow-hidden border-4 border-white shadow-lg aspect-[3/2]">
        <img src={SAMPLE} alt="" className="w-full h-full object-cover transition-[filter] duration-500" style={{ filter: wb.filter }} data-testid="wb-preview" />
      </div>
    </div>
  );
};
